<template>
  <!-- <SmallSquare :content='content' :padding='true'></SmallSquare> -->
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb25">
        <span>
          <a-button type="primary" v-has:dealerClerkCreate="()=> {$router.push('/customer/dealer/dealer_clerkAdd?type=add')}">
            <PlusOutlined />
            新增经销商业务员
          </a-button>
        </span>
      </div>
      <a-form ref='form' :model='search' :initialValues="search" style="margin-bottom: 25px;" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item class='mb15' label="关键词" name='keyword'>
          <a-input v-model:value="search.keyword" placeholder="请输入业务员名称/手机号" />
        </a-form-item>
        <a-form-item label="核销权限" name='is_verification_order' v-if='open'>
          <a-select v-model:value="search.is_verification_order" :style="{width:'160px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">允许</a-select-option>
            <a-select-option :value="0">不允许</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="所属经销商" name='dealer_id' v-if='open'>
          <a-input v-model:value="dealer_name" readonly allClerk placeholder='请选择所属经销商' />
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 3px;" v-if='dealer_name' @click='dealer_name="";search.dealer_id="";' />
        </a-form-item>
        <a-form-item label="" name='' v-if='open'>
          <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
        <a-form-item label="创建日期" name='time' v-if='open'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="绑定微信账号" name='is_bind_wechat' v-if='open'>
          <a-select v-model:value="search.is_bind_wechat" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">绑定微信</a-select-option>
            <a-select-option :value="2">未绑定微信</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" ghost v-has:dealerClerkExport="exportTable">导出</a-button>
        </a-form-item>
        <a-form-item>
          <a href="javascript:;" @click='open = !open'>{{open ? '收起':'展开'}}</a>
          <UpOutlined v-if='open' />
          <DownOutlined v-else />
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='sale_id' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:is_verification_order="{ record }">
          <p>{{record.is_verification_order ? '允许':'不允许'}}</p>
        </template>
        <template v-slot:is_bind_wechat="{ record }">
          <a-popover placement="right" v-if='record.wechat'>
            <template #content>
              <div class="s_flex_ali">
                <img class="width-100 height-100 m-r-15" :src="record.wechat ? record.wechat.headimgurl :''" alt="">
                <div>
                  <p class="s_c333 s_lin_h28">微信昵称：{{record.wechat ? record.wechat.nick_name :'-'}}</p>
                  <p class="s_c333 s_lin_h28">客户ID：{{record.wechat ? record.wechat.id :'-'}}</p>
                  <p class="s_c333 s_lin_h28">地区：{{record.wechat ? record.wechat.area :'-'}}</p>
                  <p class="s_c333 s_lin_h28">会员等级：{{record.wechat ? record.wechat.vip_level :'-'}}</p>
                </div>
              </div>
            </template>
            <a href="javascript:;" class="s_omit width-120 ds-b">{{record.wechat ? record.wechat.nick_name :'-'}}</a>
          </a-popover>
          <p v-else>-</p>
        </template>
        <template v-slot:status="{ record }">
          <p>{{record.status ? '正常':'禁用'}}</p>
        </template>
        <template v-slot:action="{ record }">
          <a-button v-has:dealerClerkDetail="()=> {$router.push('/customer/dealer/dealer_clerkDetail?type=look&id='+record.sale_id)}" class="m-r-5">详情</a-button>
          <a-button type="primary" v-has:dealerClerkEdit="()=> {$router.push('/customer/dealer/dealer_clerkEdit?type=edit&id='+record.sale_id)}" class="m-r-5">编辑</a-button>
          <a-button v-has:dealerClerkStatus="()=> clerkDisable(record)" class="m-r-5">{{record.status ? '禁用':'启用'}}</a-button>
          <!--   <a v-has:dealerClerkDel="()=> delClerk(record)" href="javascript:;">删除</a> -->

        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect"></selectDealer>
  </a-modal>
</template>
<script>
import {
  DownOutlined,
  PlusOutlined,
  UpOutlined,
  CloseCircleFilled,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getClerkList, clerkDel, clerkEnable } from "@/api/dealer";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  page: 1,
  limit: 10,
  start_time: "",
  end_time: "",
  status: "",
  dealer_id: "",
  is_verification_order: "",
  is_bind_wechat: "",
};
export default {
  components: { DownOutlined, PlusOutlined, UpOutlined, CloseCircleFilled },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      dealer_name: "",
      showDealer: false,
      open: false,
      listLoading: false,
      time: [],
      total: 1,
      selectedRowKeys: [],
      content: "经销商业务员介绍",
    });
    let columns = [
      {
        title: "业务员ID",
        dataIndex: "sale_id",
        key: "sale_id",
      },
      {
        title: "业务员名称",
        dataIndex: "sale_name",
        key: "sale_name",
        width: 200,
      },
      {
        title: "登录账号",
        dataIndex: "account",
        key: "account",
      },
      {
        title: "核销权限",
        dataIndex: "is_verification_order",
        slots: { customRender: "is_verification_order" },
      },
      {
        title: "绑定微信",
        dataIndex: "is_bind_wechat",
        slots: { customRender: "is_bind_wechat" },
      },
      {
        title: "所属经销商",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "状态",
        dataIndex: "status",
        slots: { customRender: "status" },
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
        width: 200,
      },
      {
        title: "最后登录时间",
        dataIndex: "last_login_time",
        key: "last_login_time",
        customRender: ({ text, record }) => {
          return record.last_login_time ? record.last_login_time : "-";
        },
        width: 200,
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    //选择经销商
    const dealerSelect = (e) => {
      if (e == 0) {
        state.dealer_name = "总部";
        search.value.dealer_id = e;
      } else {
        state.dealer_name = e.dealer_name;
        search.value.dealer_id = e.dealer_id;
      }
      state.showDealer = false;
    };
    // 业务员禁用启用
    const clerkDisable = (e) => {
      $Modal.confirm({
        centered: true,
        title: e.status ? "业务员禁用" : "业务员启用",
        content: "您确定要" + (e.status ? "禁用" : "启用") + "该业务员吗？",
        onOk: async () => {
          let res = await clerkEnable(e.sale_id).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //删除业务员
    const delClerk = (e) => {
      $Modal.confirm({
        centered: true,
        title: "业务员删除",
        content: "删除后该业务员将无法恢复，您确定要删除该业务员吗？",
        onOk: async () => {
          let res = await clerkDel(e.sale_id).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getClerkList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.list;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });
    // 导出
    const exportTable = async () => {
      let res = await getClerkList({ ...search.value, excel: 1 }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        window.open(res.data.action);
      }
    };
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      clerkDisable,
      delClerk,
      onSelectChange,
      dealerSelect,
      inputSelect,
      exportTable,
    };
  },
};
</script>